
<div
  ref="outdated-modal"
  class="outdated-modal"
  @click="clickOutside"
>
  <div class="grey-background"></div>
  <div class="dialogbox-wrapper">
    <div
      ref="dialogbox-content"
      class="dialogbox-content"
    >
      <div class="modal-img-wrap">
        <img
          :src="oldCompImage"
          class="modal-img"
          alt="computer"
        />
      </div>
      <!-- eslint-disable vue/no-v-html -->
      <h5 v-html="xss($t('wsk.out_modal.title'))"></h5>
      <p>{{ $t('wsk.out_modal.text') }}</p>
      <div class="delimiter">
        <hr />
        <div class="text">
          <span>{{ $t('wsk.out_modal.delimiter_text') }}</span>
        </div>
      </div>
      <div class="browser-links">
        <a
          href="https://google.com/chrome/"
          target="_blank"
          class="browser-link left discreet-link"
        >
          <img
            :src="chromeIcon"
            alt="chrome"
          />
          <div class="text">
            <h5>Google&nbsp;Chrome</h5>
            <span>google.com/chrome</span>
          </div>
        </a>
        <a
          href="https://mozilla.org/firefox"
          target="_blank"
          class="browser-link right discreet-link"
        >
          <img
            :src="ffIcon"
            alt="firefox"
          />
          <div class="text">
            <h5>Firefox</h5>
            <span>mozilla.org/firefox</span>
          </div>
        </a>
      </div>

      <button
        :aria-label="$t('wsk.general.close')"
        :title="$t('wsk.general.close')"
        type="button"
        class="close outdated-corner-close"
        @click="hide()"
      >
        ×
      </button>
    </div>
  </div>
</div>
